export default __webpack_public_path__ + "static/media/bankAcount.6ad4c7e5.svg";